import script from "./MovimentacaoBancariaRelatorio.vue?vue&type=script&setup=true&lang=js"
export * from "./MovimentacaoBancariaRelatorio.vue?vue&type=script&setup=true&lang=js"

import "./MovimentacaoBancariaRelatorio.vue?vue&type=style&index=0&id=52b74dc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b74dc8"]])

export default __exports__